import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IconCross } from '@xing-com/icons';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';
import { Tag as BaseTag } from '@xing-com/tag';
import { scale110, spaceM, spaceS } from '@xing-com/tokens';

export const TagContainer = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceS};

  @media ${mediaTopBarHidden} {
    /* On desktop it is displayed under the search hero */
    margin-bottom: ${spaceM};
  }
`;

export const Tag = styled(BaseTag).attrs({
  selected: true,
  trailingIcon: IconCross,
})`
  @media ${mediaTopBarHidden} {
    height: ${scale110};

    & > button {
      height: ${scale110};
    }
  }
`;

export const ResetButton = styled(Button)`
  flex-shrink: 0;

  @media ${mediaTopBarHidden} {
    height: ${scale110};
  }
`;
